<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Service in Progress</h4>
</div>
<div class="modal-body">
    <ng-container *ngIf="context && context.originalOwner && context.recipient">
        <p>{{context.originalOwner.firstName}} {{context.originalOwner.lastName}} is currently working on this service.</p>
        <p>Are you sure you want to reassign it to {{context.recipient.firstName}} {{context.recipient.lastName}}?</p>
    </ng-container>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" aria-label="Close" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button class="btn--accent" type="submit" data-bs-dismiss="modal" (click)="accept()">Reassign</button>
    </div>
</div>
